import { styled } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { colorPalette } from '../../style/colorPalette'

export type NoticeTone = 'warning' | 'info'

type Props = {
  messageId?: string
  tone?: NoticeTone
}

export const NoticeText = ({ messageId, tone = 'warning' }: Props) => {
  if (!messageId) {
    // 通知の有無で高さが変わらないよう、常に1行分の要素を描画する
    return <>&nbsp;</>
  }
  const Notice = tone === 'warning' ? WarningNotice : InfoNotice
  return (
    <Notice role="status" aria-live="polite">
      <FormattedMessage id={messageId} />
    </Notice>
  )
}

const WarningNotice = styled('span')({
  color: colorPalette.pink[3],
})

const InfoNotice = styled('span')({
  color: colorPalette.skyBlue[8],
})
